
import PropTypes from 'prop-types';
import Select from 'react-select';

const AutoCompleteInput = ({
  options,
  onChange,
  onSelect, // הוספת prop חדש
  placeholder,
  value,
  name,
  labelText,
  onScroll,
  isLoading,
  ...props
}) => {
  const customStyles = {
    // ... (השאר את ה-styles כמו שהם)
  };

  const formattedOptions = options.map((option) => ({
    value: option,
    label: option,
  }));

  return (
    <div className='form-row'>
      <label htmlFor={name} className='form-label'>
        {labelText || name}
      </label>
      <Select
        {...props}
        styles={customStyles}
        options={formattedOptions}
        placeholder={placeholder}
        type='text'
        onChange={(selectedOption) => {
          // קריאה ל-onSelect כשיש בחירה אמיתית
          if (selectedOption) {
            onSelect?.(selectedOption);
          }
          // המשך הטיפול הרגיל ב-onChange
          onChange({
            target: {
              name,
              value: selectedOption ? selectedOption.value : '',
            },
          });
        }}
        onInputChange={(inputValue, { action }) => {
          if (action === 'input-change') {
            onChange({
              target: {
                name,
                value: inputValue,
              },
            });
          }
        }}
        value={formattedOptions.find((option) => option.value === value)}
        isClearable={true}
        isSearchable={true}
        isLoading={isLoading}
        onMenuScrollToBottom={onScroll}
      />
    </div>
  );
};

AutoCompleteInput.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func, // הוספת prop type חדש
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onScroll: PropTypes.func,
  isLoading: PropTypes.bool,
};
export default AutoCompleteInput;